import { ExamDocumentType } from "src/app/services/exam/enums/document-type.enum";
import { IFeatureRestrictionPreset } from "src/models/FeatureRestrictionPreset";

export interface IExamPageModel {
  recordsCount: number;
  examsList : IExamListModel[]
}

export interface IExamListModel {
  id: number;
  userId: string;
  name: string;
  examDate: ITimeModel;
  unlockCode: string;
  accessCode: string;
  examStatus: ExamStatus;
  ownerName: string;
  numberOfStudents: number;
  students: IStudentModel[];
  studentsStatuses: string[];
}

export enum ExamStatus {
  Pending = 0,
  InProgress = 1,
  Submitted = 2
}

export interface IExamModel {
  id: number;
  userId: string;
  examName: string;
  subject: string;
  students: IStudentModel[];
  driveId: number;
  // driveInfo: WolandCloudDriveAuthInfo;
  examFile: IExamFile;
  attachments: IExamFile[];
  examDate: ITimeModel;
  unlockCode: string;
  featureRestriction: IFeatureRestrictionPreset;
  isAllowDraft: boolean;
  isStoreDraft: boolean;
  cloudType: string;
  email: string;
  userName: string;
  createDate: string;
}

export interface IExamListFilterModel {
  sortColumn: string;
  sortDirection: string;
  pageSize: number;
  currentPage: number;
}

export interface IDriveInfo {
  id: number;
  accessToken: string;
  refreshToken: string;
  driveType: number;
  expiredDate: string;
}

export interface IExamFile {
  name: string;
  path: string;
}

export interface IExamDocument {
  name: string;
  path: string;
  documentType: ExamDocumentType;
}

export interface ITimeModel {
  startFromDate: string;
  startUntilDate: string;
  endDate: string;
  duration: number;
  displayTimeLeft: boolean;
  displayCurrentTime: boolean;
}

export interface IStudentModel {
  name: string;
  userName: string;
  email: string;
  userId: string;
  startDate: string;
  endDate: string;
  unlockCodeEnterAttempts: number;
  isSubmitted: boolean;
}

export interface TabData {
  id: string;
  name: string;
}
